<template>
    <div class="container">
        <b-modal
            :model-value="showFila"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            size="lg"
            :title="labels.newRow"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            @hide="clickClose">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.filaNumeric }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input
                            type="number"
                            v-model="filaNumeric"
                            class="form-input"
                            :placeholder="labels.filaNumericPlaceholder"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.filaName }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input
                            type="text"
                            v-model="fila"
                            class="form-input"
                            :placeholder="labels.filaNamePlaceholder"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clickClose">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="saveFila">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EcpReporte from '../../services/EcpReporte'

export default {
    name: "NewFila",
    props: {
        showFila: {
            type: Boolean,
            default: false
        },
        listaFilas: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        filaNumeric: '',
        fila: ''
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    newRow: "Agregar Fila",
                    infoTitle: "Nueva Fila",
                    infoText: "Ingresa los datos de la nueva fila y guarda los cambios.",
                    filaName: "Nombre:",
                    filaNamePlaceholder: "Ingrese el nombre de la fila",
                    filaNumeric: "Fila (Números):",
                    filaNumericPlaceholder: "Ingrese el número de fila (Ej: 1, 2, 3...)",
                    save: "Guardar",
                    close: "Cerrar",
                    duplicateRow: "La fila ya existe. Ingrese un número de fila diferente.",
                    requiredFields: "Hay campos pendientes por diligenciar"
                }
            } else {
                return {
                    newRow: "Add Row",
                    infoTitle: "New Row",
                    infoText: "Enter the new row data and save the changes.",
                    filaName: "Name:",
                    filaNamePlaceholder: "Enter row name",
                    filaNumeric: "Row (Numeric):",
                    filaNumericPlaceholder: "Enter row number (Eg: 1, 2, 3...)",
                    save: "Save",
                    close: "Close",
                    duplicateRow: "The row already exists. Enter a different row number.",
                    requiredFields: "There are fields pending completion"
                }
            }
        }
    },
    methods: {
        clickClose() {
            this.$emit('closeModal', false)
        },

        filaYaExiste(numeroFila) {
            if (!Array.isArray(this.listaFilas)) return false
            const numeroStr = String(numeroFila).trim()
            return this.listaFilas.some(item => {
                const valorFila = item?.fila ?? item?.codigo ?? item?.numero
                if (valorFila === undefined || valorFila === null) return false
                return String(valorFila).trim() === numeroStr
            })
        },

        saveFila() {
            if (this.fila == "" || this.filaNumeric == "") {
                this.$toast.error(this.labels.requiredFields)
                return
            }

            if (this.filaYaExiste(this.filaNumeric)) {
                this.$toast.error(this.labels.duplicateRow)
                return
            }

            const dataForm = {
                'fila': this.filaNumeric,
                'nombreFila': this.fila,
                'idUser': this.$store.state.userId
            }

            EcpReporte.insertFila(dataForm)
                .then((res) => {
                    this.$toast.success(res.data.message)
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error(err)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.reloadTblFila()
                        this.filaNumeric = ""
                        this.fila = ""
                    }, 3000);
                })
        },

        reloadTblFila() {
            this.$emit('reloadTblFila', false)
        }
    }
}
</script>

<style src="../main.css"></style>